import axios from 'axios'

const BASE = () => `${process.env.VUE_APP_BACKEND_URL}/api/superadmin/news`

function prepareParams(config) {
    const field =
        config.sortDirection === 'desc' ? `-${config.sort}` : config.sort

    const params = {
        page: config.page,
        include: config.include,
        sort: field,
        per_page: config.per_page
    }

    if (config.search) params.search = config.search

    if (config.filters) {
        for (const [key, value] of Object.entries(config.filters)) {
            if (value === null || value === undefined || value === '') continue
            params[`filter[${key}]`] = value
        }
    }

    return params
}

export default {
    getArticles({ state, commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get(BASE(), { params: prepareParams(state.articlesConfig) })
                .then((response) => {
                    commit('setArticles', response.data.articles)
                    resolve(response)
                })
                .catch(reject)
        })
    },

    getArticle({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${BASE()}/${id}`)
                .then((response) => {
                    commit('setArticle', response.data.article)
                    resolve(response)
                })
                .catch(reject)
        })
    },

    createArticle(_, payload) {
        return axios.post(BASE(), payload)
    },

    updateArticle(_, { id, payload }) {
        return axios.put(`${BASE()}/${id}`, payload)
    },

    deleteArticle(_, id) {
        return axios.delete(`${BASE()}/${id}`)
    },

    publishArticle(_, id) {
        return axios.put(`${BASE()}/${id}/publish`)
    },

    unpublishArticle(_, id) {
        return axios.put(`${BASE()}/${id}/unpublish`)
    }
}
